/* tslint:disable */
/* eslint-disable */
/**
 * mama health backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterUserDto
 */
export interface RegisterUserDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterUserDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserDto
     */
    token: string;
}

/**
 * Check if a given object implements the RegisterUserDto interface.
 */
export function instanceOfRegisterUserDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function RegisterUserDtoFromJSON(json: any): RegisterUserDto {
    return RegisterUserDtoFromJSONTyped(json, false);
}

export function RegisterUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'token': json['token'],
    };
}

export function RegisterUserDtoToJSON(value?: RegisterUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'token': value.token,
    };
}

